const accountNumberValidator = value => {
  const pattern = /\b[a-zA-Z]?\d+(?![^a-zA-Z\d])\b/;
  return pattern.test(value) ? undefined : 'Enter a valid account number.';
};

export { accountNumberValidator };
